import angular from 'angular';

angular.module('cxRelations').directive('cxVatUnit', [
  function() {
    return {
      restrict: 'E',
      template: require('./vatUnit.html'),
      scope: {
        vatUnit: '=',
        disabled: '=',
        relationId: '=',
      },
      bindToController: true,
      controllerAs: 'vm',
      require: ['^cxRelationFile', 'cxVatUnit'],
      link: function(scope, el, attrs, controllers) {
        if (!controllers || controllers.length !== 2) return;
        var cxRelFile = controllers[0];
        var controller = controllers[1];
        controller.setRelationFile(cxRelFile);
      },
      controller: [
        '$scope',
        'flySvc',
        'resourceFactorySvc',
        function($scope, flySvc, resourceFactorySvc) {
          var vm = this;
          var relationFile = null;
          vm.setRelationFile = function(relFile) {
            relationFile = relFile;
          };

          vm.relationChanged = function(selectedValue) {
            if (!vm.vatUnit && !selectedValue) return false;
            if (selectedValue && vm.vatUnit && selectedValue.id == vm.vatUnit.id) return false; // Not changed

            var resource = resourceFactorySvc.get('relationLink');
            const model = {
              linkType: 12,
              toRelationId: selectedValue.id,
              fromRelationId: vm.relationId,
            };

            vm.saving = true;

            if (selectedValue) {
              return resource.save(
                {},
                model,
                function(result) {
                  vm.saving = false;
                  flySvc.success('msgConfirmChange');

                  vm.vatUnit = {
                    ...result.target,
                    linkId: result.id,
                  };
                  return true;
                },
                function(error) {
                  vm.saving = false;
                  flySvc.error(error);
                  return '';
                },
              );
            } else {
              return resource.delete({ id: vm.vatUnit.linkId }).$promise.then(
                function(result) {
                  vm.saving = false;
                  flySvc.success('msgConfirmChange');

                  return true;
                },
                function(error) {
                  vm.saving = false;
                  flySvc.error(error);
                  return false;
                },
              );
            }
          };
        },
      ],
    };
  },
]);
